import React, { useState }  from 'react';
import { InputSection, Label, InputGroup, IdInput, CheckButton, Message } from './style';

const IdInputSection = ({ userId, setUserId, isIdChecked, setIsIdChecked, idMessage, setIdMessage, onIdCheck }) => {
    
    // 아이디 입력 변경 핸들러
    const handleUserIdChange = (e) => {
        const value = e.target.value;
        setUserId(value);
        setIsIdChecked(false);

        // 영문자와 숫자만 허용하는 정규식
        const regex = /^[a-z0-9]*$/;

        if (value.length > 15 || value.length < 5) {
            setIdMessage('⚠️ 아이디는 5자 이상 15자 이내로 입력해주세요.');
        } else if (!regex.test(value)) {
            setIdMessage('⚠️ 아이디는 영문자(소문자)와 숫자만 입력 가능합니다.');
        } else if (value.length === 0) {
            setIdMessage('');
        } else {
            setIdMessage('아이디 중복확인이 필요합니다.');
        }
    };

    return (
        <InputSection>
            <Label htmlFor="userId">아이디</Label>
            <InputGroup>
                <IdInput
                    type="text"
                    id="userId"
                    value={userId}
                    onChange={handleUserIdChange}
                    placeholder="영문자(소문자)와 숫자만 입력"
                />
                <CheckButton type="button" onClick={onIdCheck} disabled={
                    userId.length === 0 || (idMessage.length > 0 && idMessage !== '아이디 중복확인이 필요합니다.')
                }>
                    중복확인
                </CheckButton>
            </InputGroup>
            {idMessage && (
                <Message
                    isError={
                        idMessage.startsWith('⚠️') || idMessage.includes('이미 사용 중') || idMessage.includes('오류')
                    }
                    isSuccess={idMessage.includes('사용 가능한')}
                >
                    {idMessage}
                </Message>
            )}
        </InputSection>
    );
};

export default IdInputSection;
